module.exports = require("core-js-pure/features/instance/fill");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/instance/fill.js
// module id = 474
// module chunks = 13